export const generateVouchersOptions = (vouchers) =>
  vouchers.map((item) => ({
    label: item.voucher,
    value: item.voucher,
  }));

// GENERATE OPTIONS FOR STORE DROPDOWN
export const generateStoresOptions = (stores) =>
  stores.map((store) => ({
    label: store.name,
    value: store.id,
    ...store,
  }));

// GENERATE OPTIONS FOR BRANCH DROPDOWN
export const generateBranchesOptions = (branches) =>
  branches.map((branch) => ({
    label: `${branch.name} ${branch.address ? `: ${branch.address}` : ""}`,
    value: branch.id,
    ...branch,
  }));

// GENERATE OPTIONS FOR PRODUCT DROPDOWN
export const generateProductsOptions = (products) =>
  products.map((product) => ({
    label: product.name,
    value: product.id,
    quantity: 1,
    ...product,
  }));

// GENERATE OPTIONS FOR SKUS DROPDOWN
export const generateSkusOptions = (skus) =>
  skus.map((sku) => ({
    label: sku.product_code,
    value: sku.id,
    ...sku,
  }));

// GENERATE OPTIONS FOR REJECT DROPDOWN
export const generateRejectRemarksOptions = (rejectRemarks) =>
  rejectRemarks.map((remark) => ({
    label: remark.name,
    value: remark.code,
    ...remark,
  }));

// GENERATE OPTIONS FOR STATUS DROPDOWN
export const statusOption = [
  { value: "VALID", label: "VALID" },
  { value: "INVALID", label: "INVALID" },
  { value: "PENDING", label: "PENDING" },
  { value: "DISCARDED", label: "DISCARDED" },
];

export const customerOption = [
  { value: "has_transactions", label: "Has Transactions" },
  { value: "has_recurring_token", label: "Has Recurring Token" },
  { value: "is_registered", label: "Is Registered" },
];
